var _styled;

// https://github.com/alphagov/govuk_frontend_toolkit/blob/master/stylesheets/_grid_layout.scss
// https://github.com/alphagov/govuk_elements/blob/master/assets/sass/elements/_layout.scss
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { MEDIA_QUERIES, SITE_WIDTH, SPACING } from '@govuk-react/constants';
var StyledRow = styled('div')((_styled = {
  width: '100%',
  clear: 'left',
  margin: "0 0 " + SPACING.SCALE_3
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  display: 'flex',
  maxWidth: SITE_WIDTH,
  marginBottom: SPACING.SCALE_5
}, _styled));

var GridRow = function GridRow(_ref) {
  var children = _ref.children;
  return React.createElement(StyledRow, null, children);
};

GridRow.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};
export default GridRow;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/grid-row/es/index.js
// module id = 81
// module chunks = 0